<div class="operation-feedback-item">
  <div class="operation-feedback-item-wrapper">
    <div class="operation-feedback-item-status" [ngSwitch]="data.status">
      <div *ngSwitchCase="operationFeedbackItemDownloadStatus.Progress">
        <fw-progress-spinner [mode]="progressValue ? 'determinate' : 'indeterminate'" size="small"
          [value]="progressValue"></fw-progress-spinner>
      </div>
      <div *ngSwitchCase="operationFeedbackItemDownloadStatus.Failed"><fw-icon size="medium"
          color="red">warning-circle</fw-icon></div>
      <div *ngSwitchCase="operationFeedbackItemDownloadStatus.Completed"><fw-icon size="medium"
          color="green">done-check-tracked</fw-icon></div>
    </div>
    <div>
      <fw-tooltip [title]="data.title">
        <div class="operation-feedback-item-title">{{title}}</div>
      </fw-tooltip>
      <div class="operation-feedback-item-subtitle">
        @if (data.currentFile && data.status !== operationFeedbackItemDownloadStatus.Completed) {
        <div>
          <fw-tooltip [maxWidth]="490" [title]="data.currentFile">
            <div>
              {{currentFileShortName}}
            </div>
          </fw-tooltip>
        </div>
        }

        {{ data.downloadedSize ? (data.downloadedSize | storageUnit) : ''}}
        @if (data.downloadedSize && data.totalSize) {
        / {{ data.totalSize | storageUnit }}
        }

        <ng-container *ngIf="timeLeftData$ | async as timeLeft">
          @if(timeLeft && data.status === operationFeedbackItemDownloadStatus.Progress) {
            · {{ timeLeft | formatTime}}
          }
        </ng-container>

      </div>
    </div>
  </div>
  <div class="operation-feedback-item-wrapper">
    @if(data.status === operationFeedbackItemDownloadStatus.Failed) {
      <fw-icon-button (click)="refresh.emit(data)"
                      color="slate" icon="rotate-refresh" size="small"></fw-icon-button>
    }

    <div>
      <fw-icon-button (click)="onCancelClick()" color="slate" icon="close" size="small"></fw-icon-button>
      <div #popoverTrigger class="operation-feedback-item-action-popover-trigger">
      </div>
    </div>

    <fw-popover [trigger]="popoverTrigger" action="click" position="above-left">
      <operation-cancel-popover-body (onCancelClick)="closePopover()"
        (onSubmitClick)="cancel.emit(data); closePopover() "
        [cancelTitle]="'operationFeedback.itemPopover.cancelTitle' | translate"
        [submitTitle]="'operationFeedback.itemPopover.submitTitle' | translate"
        [text]="'operationFeedback.itemPopover.text' | translate"
        [title]="'operationFeedback.itemPopover.title' | translate"></operation-cancel-popover-body>
    </fw-popover>
  </div>
